import { type SuggestionAddress } from "./AddressAutoComplete.tsx"

/**
 * One ZIP is the address's own; several mean the geocoder could not narrow it,
 * so the address's own ZIP stands and the caller offers the rest as a choice.
 *
 * Always a value or `null`, never `undefined`: antd leaves a field untouched on
 * `undefined` and clears it on `null`, and a suggestion that carries no ZIP has
 * to clear the one already there.
 */
const suggestionZip = (suggestion: SuggestionAddress): string | null =>
  (suggestion?.city_zips?.length === 1
    ? suggestion?.city_zips?.[0]?.zip_code
    : suggestion?.address?.zip_code) || null

export { suggestionZip }
